// SEC-17 — client-side mirror of the backend per-file upload caps.
// The backend (services/upload_limits.py) is authoritative; these power
// friendly "fail fast" pre-checks + "Max N MB" hints in the UI.
export const MB = 1024 * 1024;

// purpose -> max size in MB (must match backend CATEGORY_LIMITS)
export const UPLOAD_LIMITS_MB = {
  image: 10,
  video: 100,
  pitchdeck: 30,
  resource: 50,
  event: 25,
  tag_icons: 2,
  seo_og: 5,
  general: 25,
};

const NOUN = {
  image: "image",
  video: "video",
  pitchdeck: "PDF or pitch deck",
  resource: "file",
  event: "file",
  tag_icons: "icon",
  seo_og: "image",
  general: "file",
};

export function limitMb(purpose) {
  const v = UPLOAD_LIMITS_MB[purpose];
  return v == null ? UPLOAD_LIMITS_MB.general : v;
}

export function limitHint(purpose) {
  return `Max ${limitMb(purpose)} MB`;
}

// Returns { ok: true } or { ok: false, message } for a friendly pre-check.
export function validateUpload(file, purpose = "general") {
  if (file && file.size > limitMb(purpose) * MB) {
    return {
      ok: false,
      message: `This ${NOUN[purpose] || "file"} is too large. The maximum size is ${limitMb(purpose)} MB.`,
    };
  }
  return { ok: true };
}
